module.exports = __webpack_public_path__ + "static/Equal-Housing-Lender-Black-7fcb75bd592cf7df60dd1be74a2142d3.png";